module.exports = __webpack_public_path__ + "img/logo-weis.cdcf0b01.svg";